import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8ddrqg68a: FaireProductEntity = {
  token: "p_g8ddrqg68a",
  type: "product",
  name: "Ginger Lemon",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/e331d5418a5b84645d9877f6baaa6e81bdae97805efecd25792559248aed2b8c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9017852da47d52868685f2a68c4dfc61c21c150216f59d539f532937504fc290.png",
    "https://cdn.faire.com/fastly/4413acf88dd5e18e4659877ccf34ae581b155437b9a70e13f23e4ad3da6313ba.png",
    "https://cdn.faire.com/fastly/99bb5a17375677be2224a994ffe1061afd38d693d8bcdb8cc85568f9d9bc5fc7.png",
    "https://cdn.faire.com/fastly/e3cadc76a94d3dc0de948d25d791335626d45a62958d9afa1593043c16e11552.png",
  ],
  priceDollars: 28.99,
  description:
    "Our sweet and tart Ginger Lemon combines both Caribbean and European mulling spices to create a complex flavor that manages to remain perfectly balanced. Enjoy a delightful kick of ginger followed by a tangy hint of lemon juice.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:13.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
